(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 959px)');

  function syncDuplicateGalleries() {
    var isMobile = MOBILE_MQ.matches;

    document.querySelectorAll('.product').forEach(function (product) {
      var mobile = product.querySelector('.product__media-container.below-mobile');
      var desktop = product.querySelector('.product__media-container.above-mobile');

      if (mobile) {
        mobile.setAttribute('aria-hidden', isMobile ? 'false' : 'true');
      }
      if (desktop) {
        desktop.setAttribute('aria-hidden', isMobile ? 'true' : 'false');
      }
    });
  }

  function syncHiddenMediaItems() {
    document.querySelectorAll('.product__media-item.hidden').forEach(function (item) {
      item.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.product__media-item:not(.hidden)').forEach(function (item) {
      item.removeAttribute('aria-hidden');
    });
  }

  function sync() {
    syncDuplicateGalleries();
    syncHiddenMediaItems();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  window.addEventListener('resize', syncDuplicateGalleries);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-product-thumbnail]')) {
      requestAnimationFrame(syncHiddenMediaItems);
    }
  });
})();
